"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Filters = void 0;
const filter_1 = require("./filter");
class Filters {
    constructor(filters) {
        this.filters = filters;
    }
    static fromValues(filters) {
        return new Filters(filters.map(filter_1.Filter.fromValues));
    }
    static none() {
        return new Filters([]);
    }
}
exports.Filters = Filters;
